import { DOMAIN } from "@/constants"
export const ACI_PAYMENT_CHECKOUT_ENDPOINT = "/payment/checkout"
export const ACI_PAYMENT_CHECKOUT_V1_ENDPOINT = "/payment/v1/checkout"
export const ORDER_SUBMIT_V3_ENDPOINT = "/checkout/v3/order/submit"
export const ORDER_SUBMIT_V2_ENDPOINT = "/checkout/v2/order/submit"
export const ACI_PAYMENT_CALLBACK_ENDPOINT = "/payment/checkout/callback"
export const ACI_PAYMENT_RESULT_MESSAGE_TYPE = "ACI_PAYMENT_RESULT"
export const ACI_PAYMENT_RESULT_URL = "/api/checkout/aci-payment-result"
export const FRAUD_DECLINED_MESSAGE_ENDPOINT = "/en/declined"
export const CHANGE_PASSWORD_MODEL_DATA_URL =
  "/en/my-account/change-password.model.json"
export const CHANGE_PASSWORD_ENDPOINT = "/customer/change_password"
export const CATALOG_NOTIFY_ENDPOINT = "catalog/product/oos/notify"
export const CATALOG_PROJECTION_ENDPOINT = "/catalog/product/projection"
export const FEATURE_FLAGS_API_ENDPOINT = DOMAIN + "/api/featureflags"
export const SVG_METADATA_ENDPOINT = "/catalog/svg/metadata"
export const ML_END_POINT = "https://api-kohler-int-test.azure-api.net"
export const ADOBE_TARGET_PRODUCT_RECOMMENDETION_ENDPOINT =
  "/catalog/product/recommendation"
export const PRODUCT_BEST_SELLERS = "/products/best-sellers"
export const USER_LIST_DELETE_END_POINT = "/shopping-list"
export const MY_LISTS_PAGE_PATH = "/my-account/my-lists"
export const FAVORITES_PAGE_PATH = "/my-account/my-favorites"
export const SEARCH_FULL_CATALOG = "/search/full-catalog"
export const CART_OFFER_ENDPOINT = "/cart/offer?discountCodeList=true"
export const SWATCH_ORDER_CATALOG = "/search/swatch"
export const THREEKIT_DATATABLE_END_POINT = "/catalog/product/configurator"
export const ORDER_LOGGING_ENDPOINT = DOMAIN + "/api/order-logging"
export const PCIPAL_SESSION_ENDPOINT = "/payment/agent/session"
